// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/chunks/" + {"381":"admin-screen-packages","385":"admin-calculator","528":"admin-scoring","582":"admin-airtime-certificate","835":"admin-activity-log"}[chunkId] + ".js?id=" + {"381":"c463496e5a42f6d3","385":"75b19d5899a7fc39","528":"b0b4c93490bd60b6","582":"930a155cd9cc5043","835":"b54d4acdf341cca2"}[chunkId] + "";
};